import React from 'react'
import * as styles from './ProductCard.module.scss'
import Link, { LinkProps } from '../link'

export interface ProductCardProps {
  image?: string
  title: string
  bodyCopy: string
  justifyContentBody?: React.CSSProperties['justifyContent']
  alignItems?: React.CSSProperties['alignItems']
  link?: LinkProps
}

const ProductCard: React.FC<ProductCardProps> = ({
  image,
  title,
  bodyCopy,
  justifyContentBody,
  alignItems = 'center',
  link
}) => {
  return (
    <div className={styles.card}>
      {image && (
        <div className={styles.image}>
          <img src={image} alt={title} />
        </div>
      )}
      <div
        className={styles.content}
        style={{
          justifyContent: justifyContentBody,
          alignItems: alignItems,
          ...(image ? {} : { flex: 1 })
        }}
      >
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.body}>{bodyCopy}</p>
        {link && <Link {...link} />}
      </div>
    </div>
  )
}

export default ProductCard
